// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgBone = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.8 3.6a2 2 0 0 1 3.967-.366A2 2 0 1 1 11.4 6.933L6.933 11.4a2 2 0 1 1-3.7 1.366 2 2 0 1 1 1.366-3.7L9.067 4.6A1.992 1.992 0 0 1 8.8 3.6Zm2-.8a.8.8 0 0 0-.532 1.398.6.6 0 0 1 .026.872L5.07 10.294a.6.6 0 0 1-.872-.026.8.8 0 1 0-.473 1.322.6.6 0 0 1 .685.685.8.8 0 1 0 1.322-.473.6.6 0 0 1-.025-.872l5.223-5.223a.6.6 0 0 1 .872.025.8.8 0 1 0 .473-1.322.6.6 0 0 1-.684-.685.8.8 0 0 0-.79-.925Z"
    />
  </svg>
)

export default SvgBone
